import axios from "axios";

export const state = {
    combinations: [],
};

export const getters = {
    combinations: state => state.combinations,
};

export const mutations = {
    setCombinations(state, newValue) {
        state.combinations = newValue
    },
};

export const actions = {
    fetchCombinations({ commit }) {
        axios.get('/combinations').then(res => {
            commit('setCombinations', res.data.combinations);
        })
    },
};
